import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconH2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.872 16.488c0 1.733 0 3.465-0.040 5.138l-1.832 0.219v0.817h5.616v-0.817l-1.812-0.199c-0.040-1.633-0.040-3.306-0.040-5.337h6.433c0 1.852 0 3.625-0.040 5.318l-1.832 0.219v0.817h5.616v-0.817l-1.832-0.219c-0.040-1.713-0.040-3.426-0.040-5.138v-0.976c0-1.733 0-3.465 0.040-5.138l1.832-0.219v-0.817h-5.616v0.817l1.832 0.219c0.040 1.613 0.040 3.246 0.040 4.999h-6.433c0-1.593 0-3.326 0.040-5.019l1.812-0.199v-0.817h-5.616v0.817l1.832 0.219c0.040 1.713 0.040 3.426 0.040 5.138v0.976zM19.815 22.662h8.185v-1.633h-6.672c0.817-0.757 1.613-1.514 2.151-2.051 3.067-2.947 3.943-4.302 3.943-6.054 0-1.992-1.115-3.386-3.684-3.386-2.012 0-3.804 0.976-4.023 3.087 0.219 0.398 0.578 0.637 1.016 0.637 0.558 0 0.896-0.378 1.155-1.354l0.378-1.374c0.379-0.080 0.717-0.1 0.976-0.1 1.454 0 2.39 1.036 2.39 2.669 0 1.553-0.896 3.186-2.888 5.278-0.856 0.896-1.872 1.952-2.928 2.987v1.295z"
	})
});
export { SvgIconH2 as ReactComponent };
